import React from 'react'
import './Policy.scss'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react'
import Loader from '../Loader/Loader'

const Policies = () => {
    const location = useLocation(); // Get current location
    const [policies, setPolicies] = useState([]);
    const [load, setLoad] = useState(true);
    const [err, setErr] = useState(null);
    const queryParams = new URLSearchParams(location.search);
    const type = queryParams.get('id');

    useEffect(() => {
        const fetchPolicies = async () => {
            setLoad(true);
            try {
                const response = await fetch(`https://backend.indianjewelryish.com/api/policy/${type}`);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setPolicies(data.policy);
                setErr(null);
            } catch (error) {
                setErr(error.message);
            } finally {
                setLoad(false);
            }
        };
    
        window.scrollTo(0, 0);
        if (type) fetchPolicies();
    }, [type]);
    
    if (load) {
        return <div className="loader"><Loader /></div>;
    }

    if (err) {
        return <div className="error">Error: {err.message}</div>;
    }

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">
                    <div className="breadcrumb">
                        <Link to='/'>Home</Link> &gt; <a href="#">{policies.policy_name}</a>
                    </div>

                    <div className="containerPolicy w-80">
                        <div id='heading1'>{policies.policy_name}</div>

                        <ol class="policy-list">
                            <div dangerouslySetInnerHTML={{ __html: policies?.policy_content }} />
                        </ol>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Policies